import { Col, Container, FormLabel, Row } from 'react-bootstrap';
import { Phone, Mail } from 'feather-icons-react';
import Input from 'components/common/form/input/Input';
import { Field, Formik } from 'formik';
import { FormGroup } from 'react-bootstrap';
import * as Yup from 'yup';
import Button from 'components/base/Button';
import Textarea from 'components/common/form/textarea/Textarea';
import emailjs from '@emailjs/browser';
import { phoneRegExp } from 'helpers/utils';

const contactDetails = [
  {
    icon: <Phone size="20" />,
    heading: 'To More Inquiry',
    value: '+91-96 2783 2783'
  },
  {
    icon: <Mail size="20" />,
    heading: 'To Send Mail',
    value: 'info@crud-operations.com'
  }
];

const ContactUs = ({ isSpecificPage }: { isSpecificPage?: boolean }) => {
  const validationSchema = Yup.object({
    username: Yup.string().required('Full name is required'),
    companyName: Yup.string().required('Company / Organization is required'),
    phoneNumber: Yup.string()
      .matches(phoneRegExp, 'Phone number is not valid')
      .required('Phone is required'),
    contactEmail: Yup.string()
      .email('Invalid email address')
      .required('Company email is required'),
    subject: Yup.string().required('Your Subject is required'),
    message: Yup.string().required('Message is required')
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleSubmit = (values: any, resetForm: any) => {
    const serviceId = process.env.REACT_APP_MAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_MAILJS_TEMPLATE_ID;
    const publicKey = process.env.REACT_APP_MAILJS_PUBLIC_KEY;

    if (serviceId && templateId && publicKey) {
      emailjs
        .send(serviceId, templateId, values, {
          publicKey: publicKey
        })
        .then(
          () => {
            console.log('SUCCESS!');
            resetForm();
          },
          (error: { text: string }) => {
            console.log('FAILED...', error.text);
            resetForm();
          }
        );
    }
  };

  return (
    <Container className="pb-14 pt-6 testimonials bg-body-highlight" fluid>
      <p className="text-center fs-4 fw-bold">
        Contact <span className="text-secondary-light">Us</span>
      </p>
      {!isSpecificPage && (
        <p className="text-center text-muted">
          Meet the passionate minds driving innovation at CRUD Beat, crafting
          solutions that inspire growth and success.
        </p>
      )}
      <Row className="mt-4 d-flex justify-content-between px-lg-14">
        <Col lg={6} md={6} sm={12} className="p-6">
          <div className="bg-body-secondary p-4 rounded">
            <div className="fs-6 fw-bold">Your Success Starts Here!</div>
            <hr />
            <Formik
              initialValues={{
                username: '',
                companyName: '',
                phoneNumber: '',
                subject: '',
                contactEmail: '',
                message: ''
              }}
              validationSchema={validationSchema}
              onSubmit={(val, { resetForm }) => handleSubmit(val, resetForm)}
            >
              {({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <Row className="g-5">
                    <Col xs={12} xl={6}>
                      <FormGroup className="text-start">
                        <FormLabel htmlFor="username">Full name*</FormLabel>
                        <Field as={Input} name="username" id="username" />
                      </FormGroup>
                    </Col>
                    <Col xs={12} xl={6}>
                      <FormGroup className="text-start">
                        <FormLabel htmlFor="companyName">
                          Company / Organization*
                        </FormLabel>
                        <Field as={Input} name="companyName" id="companyName" />
                      </FormGroup>
                    </Col>
                    <Col xs={12} xl={6}>
                      <FormGroup className="text-start">
                        <FormLabel htmlFor="phoneNumber">Phone*</FormLabel>
                        <Field as={Input} name="phoneNumber" id="phoneNumber" />
                      </FormGroup>
                    </Col>
                    <Col xs={12} xl={6}>
                      <FormGroup className="text-start">
                        <FormLabel htmlFor="contactEmail">
                          Company email*
                        </FormLabel>
                        <Field
                          as={Input}
                          name="contactEmail"
                          id="contactEmail"
                          type="email"
                          placeholder="name@example.com"
                        />
                      </FormGroup>
                    </Col>
                    <Col xs={12}>
                      <FormGroup className="text-start">
                        <FormLabel htmlFor="subject">Your Subject*</FormLabel>
                        <Field as={Input} name="subject" id="subject" />
                      </FormGroup>
                    </Col>
                    <Col xs={12}>
                      <FormGroup className="text-start">
                        <FormLabel htmlFor="message">Message*</FormLabel>
                        <Field as={Textarea} name="message" id="message" />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Button
                    variant="secondary"
                    className="px-6 rounded-2 mt-3 w-100 w-md-auto"
                    type="submit"
                    aria-label="Submit the form"
                  >
                    Submit
                  </Button>
                </form>
              )}
            </Formik>
          </div>
        </Col>
        <Col lg={6} md={6} sm={12} className="p-6">
          <div>
            <p className="text-primary fw-semibold">Drop Us A Line</p>
            <div className="fs-5 fw-bold">Connect with CRUD Beat</div>
            <p className="text-body-tertiary fs-8">
              Ready to take the first step towards unlocking opportunities,
              realizing goals, and embracing innovation? We're here and eager to
              connect.
            </p>
            <div className="mt-4 d-flex flex-column gap-4">
              {contactDetails.map((info, idx) => (
                <div key={idx} className="d-flex gap-3 align-items-center">
                  <div>{info?.icon}</div>
                  <div>
                    <div className="text-body-quaternary fs-9">
                      {info?.heading}
                    </div>
                    <div className="fs-8">{info?.value}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ContactUs;
